import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type PasswordResetSerializer = {
  email: string;
  resetCode: string;
  password: string;
  message: string;
  passwordReset: boolean;
};

export type PostPasswordResetPayloadType = (
  Pick<PasswordResetSerializer, 'email' | 'resetCode' | 'password'>
);
export type PostPasswordResetResponseType = (
  Pick<PasswordResetSerializer, 'message' | 'passwordReset'>
);

export const apiResetPassword = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostPasswordResetPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.passwordReset(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
